import React from 'react';
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  HStack,
  IconButton,
  Text,
  VStack,
  useDisclosure,
} from '@chakra-ui/react';
import { FiMenu } from 'react-icons/fi';
import SaktiSidebar from '../components/SaktiSidebar';
import SaktiPushOdooFilterBar from '../components/SaktiPushOdooFilterBar';
import SaktiPushOdooResultPanel from '../components/SaktiPushOdooResultPanel';
import { useSaktiPushOdoo } from '../hooks/useSaktiPushOdoo';
import { SAKTI_UI_SIZE } from '../uiSizes';

const SaktiPushOdooPage: React.FC = () => {
  const push = useSaktiPushOdoo();

  const {
    isOpen: isMobileSidebarOpen,
    onOpen: onMobileSidebarOpen,
    onClose: onMobileSidebarClose,
  } = useDisclosure();

  return (
    <Box minH="100vh" bg="#ECEEF1">
      <Flex align="stretch">
        <Box display={{ base: 'none', xl: 'block' }}>
          <SaktiSidebar activeMenu="push-odoo" />
        </Box>

        <Drawer
          isOpen={isMobileSidebarOpen}
          placement="left"
          onClose={onMobileSidebarClose}
          size="xs"
        >
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton zIndex={10} color="gray.500" />
            <DrawerBody p={0}>
              <SaktiSidebar activeMenu="push-odoo" />
            </DrawerBody>
          </DrawerContent>
        </Drawer>

        <Box flex={1} p={SAKTI_UI_SIZE.pagePadding} minW={0}>
          <VStack align="stretch" spacing={SAKTI_UI_SIZE.sectionGap}>
            <HStack spacing={3} align="center">
              <IconButton
                aria-label="Open menu"
                icon={<FiMenu />}
                variant="outline"
                bg="white"
                display={{ base: 'flex', xl: 'none' }}
                onClick={onMobileSidebarOpen}
              />
              <VStack align="start" spacing={0}>
                <Text
                  fontSize={SAKTI_UI_SIZE.pageTitle}
                  fontWeight="bold"
                  color="gray.900"
                  lineHeight="shorter"
                >
                  Re-sync ke Odoo
                </Text>
                <Text fontSize={SAKTI_UI_SIZE.pageSubtitle} color="gray.500">
                  Push ulang data Sakti ke Odoo per estate. Rentang tanggal maksimal 31 hari.
                </Text>
              </VStack>
            </HStack>

            <SaktiPushOdooFilterBar
              filters={push.filters}
              options={push.options}
              onFiltersChange={push.setFilters}
              onSubmit={push.submit}
              isSubmitting={push.isSubmitting}
              isDisabled={push.loadingOptions}
            />

            <SaktiPushOdooResultPanel
              job={push.job}
              result={push.result}
              isSubmitting={push.isSubmitting}
            />
          </VStack>
        </Box>
      </Flex>
    </Box>
  );
};

export default SaktiPushOdooPage;
